import styled from '@emotion/styled'
import { Popover } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const PopoverStyled = styled(Popover)`
  top: ${newTheme.spacing.sm};
  .MuiPopover-paper {
    border-radius: ${newTheme.spacing.xs};
    box-shadow: 0px 0px 10px #5c5c5c1a;

    @media screen and (max-width: 425px) {
      width: 100%;
    }
  }

  h1 {
    margin: 0;
    margin-bottom: ${newTheme.spacing.sm};
    padding: 0;
    color: ${newTheme.colors.secondary};
  }
`
